const BUCKET_TONES: Record<string, string> = {
  Perfect: 'text-emerald-700',
  'Good Enough': 'text-sky-700',
  Incomplete: 'text-amber-700',
  Incorrect: 'text-red-700',
};

/** The judge's four buckets as text colour, for where there is no room for a badge. */
export const bucketTone = (bucket: string): string => BUCKET_TONES[bucket] ?? 'text-text-body';

/** Mirrors the backend judge rule: anything but Perfect is flagged. */
export const flaggedBucket = (bucket: string): boolean => bucket !== 'Perfect';
